import { useState, useCallback } from 'react';

import { Icon } from 'ui/components/primitives';

import type { BreadcrumbMobileProps } from './Breadcrumbs.d';
import { Breadcrumbs } from './Breadcrumbs.styles';
import { Step } from './components';

export const BreadcrumbMobile = ({ children }: BreadcrumbMobileProps): JSX.Element => {
  const [isTrackVisible, toggleTrackVisibility] = useState(false);

  const handleTrackVisibility = useCallback(() => {
    toggleTrackVisibility(!isTrackVisible);
  }, [isTrackVisible]);

  return (
    <Step>
      <Icon.ArrowRight size="m" />

      <Breadcrumbs.ButtonMore onClick={handleTrackVisibility}>
        <Icon.Etc size="m" />
      </Breadcrumbs.ButtonMore>

      {isTrackVisible && (
        <Breadcrumbs.MobileList data-testid="mobile-list">{children}</Breadcrumbs.MobileList>
      )}
    </Step>
  );
};
